import { z } from 'zod'

import { type ActivityType, ActivityTypeSchema } from './activity-types.ts'

export const ActivityTypeAndDataSchema = <
  Type extends ActivityType,
  Data extends z.ZodTypeAny,
>(
  activityType: Type,
  data: Data
) =>
  z.object({
    activityType: ActivityTypeSchema.extract([activityType]),
    data: data,
  })
